export function loadScript(url, callback) {
    const script = document.createElement('script');
    script.src = url;
    script.onload = function () {
        callback();
    };
    script.onerror = function () {
        console.error('加载脚本时出错:', url);
    };
    document.head.appendChild(script);
}

// 加载快应用js
export function loadQuickAppScript(callbackLogic) {
    const scriptUrl = 'https://statres.quickapp.cn/quickapp/js/qa_router.min.js'
    loadScript(scriptUrl, ()=>{
        console.log('脚本加载成功，执行回调函数');
        callbackLogic();
    });
}